import React, { useState, useRef, useEffect } from 'react';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import api from '../../api';
import Emoji from './Emoji';
import moment from 'moment';
import ImageModal from './ImageModal';
import dots from '../../assets/profile/dots.png';
import send from '../../assets/messaging/send.png';
import smily from '../../assets/messaging/smily.png';
import block from '../../assets/messaging/block.png';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import report from '../../assets/messaging/report.png';
import deletex from '../../assets/messaging/delete.png';
import attachment from '../../assets/messaging/attachment.png';
import GreenLoader from '../../assets/greenLoader.gif';
import { collection, doc, onSnapshot, serverTimestamp, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import { config } from '../../utills';
import { UserName } from '../Elements';
import { useDispatch, useSelector } from 'react-redux';
import { getFunction } from '../../features/auth/action';
import { uploadImagesToS3 } from '../../features/general/action';
import { messageInputStyles } from '../../components/InputFields/styles';
import { getFullName, dateToFromNowDaily, getSubsctiptionStatus, getUserProfile, getUserStatus } from '../../utills/constants';
import CheckIcon from '@mui/icons-material/Check';
import {
  Box,
  TextField,
  useMediaQuery,
  ImageList,
  ImageListItem,
  Menu,
  MenuItem,
  IconButton,
  Avatar,
  Tooltip,
} from '@mui/material';
import {
  DeleteMessage,
  DeleteSuccessful,
  ReportUser,
  ReportSuccessful,
  BlockSuccessful,
  BlockUser,
} from '../../components/Modal/Message';
import {
  Time,
  Message,
  NameRow,
  Footer,
  MessagesBox,
  Header,
  FooterMain,
  SendButton,
  RightGrid,
  OtherUserMsg,
  LoggedInUserMsg,
  FirstScreen,
} from './Elements';
import { FireStore } from '../../utills/FireStore';
import Loader from '../../components/Loader/index';
import toast from 'react-hot-toast';
import { startLoading, stopLoading } from '../../features/auth/reducer';
import { useNavigate } from 'react-router-dom';
import CustomLightBox from '../../components/common/CustomLightBox';

const formatedDate = (timestamp) => {
  const date = new Date(timestamp?.seconds * 1000 + timestamp?.nanoseconds / 1000000);
  const serializableValue = new Date(date.getTime());
  return serializableValue;
  // create = formatDate(serializableValue)
};

const CustomConversationBox = ({
  messages,
  setDateMessage,
  receiverFollowers,
  receiverId,
  selectedChat,
  setisBlockOther,
  setIsDeleted,
  isDeleted,
  handleProfileRedirections,
}) => {
  const messagesEndRef = useRef(null);
  const [receiverBlockArr, setReceiverBlockArr] = useState(receiverFollowers || []);

  const { userInfo } = useSelector((state) => state.auth);
  const [open, setOpen] = React.useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentMessageImages, setCurrentMessageImages] = useState([]);

  const handleOpen = (imageUrl, messageImages) => {
    const imageIndex = messageImages.findIndex(img => img === imageUrl);
    setCurrentImageIndex(imageIndex >= 0 ? imageIndex : 0);
    setCurrentMessageImages(messageImages);
    setOpen(true);
  };
  
  const handleClose = () => setOpen(false);

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1 < currentMessageImages.length ? prev + 1 : prev));
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 >= 0 ? prev - 1 : prev));
  };

  const scrollToBottom = () => {
    messagesEndRef?.current.scrollIntoView({ block: 'end', behavior: 'instant' });
  };

  useEffect(() => {
    setReceiverBlockArr(receiverFollowers);
  }, [receiverFollowers]);

  useEffect(() => {
    var initState = true;
    var initState2 = true;
    const curentUserId = userInfo?._id;
    const roomId = selectedChat?._id;
    const chatroomsRef = collection(db, 'chatrooms');
    const ref = query(collection(chatroomsRef, roomId, 'messages'), orderBy('createdAt', 'asc'));
    const ref2 = doc(chatroomsRef, roomId);

    const observer = onSnapshot(ref, (documentSnapshot) => {
      if (initState) {
        initState = false;
      } else {
        let fdata = [];

        const data = documentSnapshot?.docs || [];

        fdata = data
          .map((item) => ({
            ...item.data(),
            _id: item.id,
          }))
          .filter((item) => {
            let isShow = true;

            item.deletedBy.forEach((element) => {
              if (element == curentUserId) {
                isShow = false;
              }
            });
            if (isShow) return item;
          });
        setDateMessage(fdata);
        FireStore.readAllMessageInRoom(roomId, receiverId);
      }
    });

    const observer2 = onSnapshot(ref2, (documentSnapshot) => {
      if (initState2) {
        initState2 = false;
      } else {
        const item = documentSnapshot.data() || [];
        let userObj = null;

        if (item) {
          if (item.userId1 && item.userId1._id == receiverId) {
            userObj = item.userId1;
          }

          if (item.userId2 && item.userId2._id == receiverId) {
            userObj = item.userId2;
          }
        }
        setReceiverBlockArr(userObj ? userObj.followers : []);
        // alert('userObj in oberrver2 ====> : ', userObj);
        setIsDeleted(getUserStatus(userObj) === 'deleted')
      }
    });
    return () => {
      observer();
      observer2();
    };
  }, [receiverId]);

  useEffect(() => {
    let blk = false;
    if (receiverBlockArr?.length > 0) {
      const dtt = receiverBlockArr;
      const fi = dtt.findIndex((x) => x.userId == userInfo?._id);
      if (fi > -1) {
        if (dtt[fi].block == true) blk = true;
      }
    }
    setisBlockOther(blk);
  }, [receiverBlockArr, selectedChat]);

  useEffect(scrollToBottom, [messages]);

  const formatMessageWithLinks = (message, isSender) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
  
    return message.split(urlRegex).map((part, index) =>
      urlRegex.test(part) ? (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: isSender? '#007BFF' : "#fff", textDecoration: 'underline' }}
        >
          {part}
        </a>
      ) : (
        <span key={index}>{part}</span>
      )
    );
  };
  

  return (
    <>
      <CustomLightBox
        open={open}
        images={currentMessageImages}
        currentIndex={currentImageIndex}
        onClose={handleClose}
        onNext={nextImage}
        onPrev={prevImage}
      />
                    <MessagesBox>
         {messages?.map((res, i) => {
           // Validate and format dates safely
           const currentMessageDate = moment(formatedDate(res.createdAt)).isValid() 
             ? moment(formatedDate(res.createdAt)).format('YYYY-MM-DD') 
             : null;
           
           const previousMessageDate = i > 0 && moment(formatedDate(messages[i - 1].createdAt)).isValid()
             ? moment(formatedDate(messages[i - 1].createdAt)).format('YYYY-MM-DD') 
             : null;
           
           // Show date separator only if we have valid dates and if this is the first message or if the date changed
           const shouldShowDateSeparator = currentMessageDate && (i === 0 || currentMessageDate !== previousMessageDate);
           
           return (
             <React.Fragment key={i}>
                               {shouldShowDateSeparator && moment(formatedDate(res.createdAt)).isValid() && (
                  <Time sx={{ textAlign: 'center', my: 2 }}>
                    <span style={{ fontWeight: 'bold' }}>
                      {dateToFromNowDaily(formatedDate(res.createdAt))}
                    </span>
                  </Time>
                )}
               
               {res?.user?._id === userInfo?._id ? (
                 <Box sx={{ paddingLeft: 3, paddingRight: 3 }}>
                   <LoggedInUserMsg>
                     {res?.image?.length === 0 ? (
                       formatMessageWithLinks(res.message, true)
                     ) : (
                       <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                         <ImageList
                           sx={{ 
                             width: 'auto', 
                             height: 'auto', 
                             color: 'black',
                             margin: 0,
                             padding: 0
                           }}
                           cols={res?.image?.length}
                         >
                           {res?.image?.map((item) => (
                             <ImageListItem key={item} sx={{ margin: '0px 2px' }}>
                               <img
                                 style={{ cursor: 'pointer' }}
                                 onClick={() => handleOpen(item, res.image)}
                                 src={`${item}?w=50&h=50&fit=crop&auto=format`}
                                 srcSet={`${item}?w=50&h=50&fit=crop&auto=format&dpr=2 2x`}
                                 alt={item}
                                 // loading="lazy"
                                 onLoad={scrollToBottom}
                               />
                             </ImageListItem>
                           ))}
                         </ImageList>
                         {res.message && (
                           <Box sx={{ 
                             marginTop: res?.image?.length > 0 ? '8px' : 0,
                             textAlign: 'left',
                             width: '100%'
                           }}>
                             {formatMessageWithLinks(res.message, true)}
                           </Box>
                         )}
                       </Box>
                     )}
                   </LoggedInUserMsg>
                                       {moment(formatedDate(res.createdAt)).isValid() && (
                      <Time
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                        }}
                      >
                        {moment(formatedDate(res.createdAt))
                          .format('hh:mm a')
                          .replace(/^0(?:0:0?)?/, '')}{' '}
                        {res?.isRead ? (
                          <DoneAllIcon sx={{ color: 'green', fontSize: 15 }} />
                        ) : (
                          <CheckIcon sx={{ fontSize: 15 }} />
                        )}
                      </Time>
                    )}
                 </Box>
               ) : (
                 <>
                   <Box
                     sx={{
                       display: 'flex',
                       flexDirection: 'row',
                       alignItems: 'flex-end',
                       paddingLeft: 2,
                       paddingRight: 2,
                     }}
                     onClick={()=> handleProfileRedirections(res?.user)}
                   >
                     <Avatar src={isDeleted ? "" : res?.user?.image} alt="convo" style={{ marginRight: 8 }} />
                     <OtherUserMsg>
                       {res?.image?.length === 0 ? (
                         formatMessageWithLinks(res.message)
                       ) : (
                         <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                           <ImageList 
                             sx={{ 
                               width: 'auto', 
                               height: 'auto',
                               margin: 0,
                               padding: 0
                             }} 
                             cols={res?.image?.length}
                           >
                             {res?.image?.map((item) => (
                               <ImageListItem key={item} sx={{ margin: '0px 2px' }}>
                                 <img
                                   onClick={() => handleOpen(item, res.image)}
                                   src={`${item}?w=50&h=50&fit=crop&auto=format`}
                                   srcSet={`${item}?w=50&h=50&fit=crop&auto=format&dpr=2 2x`}
                                   alt={item}
                                   // loading="lazy"
                                   onLoad={scrollToBottom}
                                 />
                               </ImageListItem>
                             ))}
                           </ImageList>
                           {res.message && (
                             <Box sx={{ 
                               marginTop: res?.image?.length > 0 ? '8px' : 0,
                               textAlign: 'left',
                               width: '100%'
                             }}>
                               {formatMessageWithLinks(res.message)}
                             </Box>
                           )}
                         </Box>
                       )}
                     </OtherUserMsg>
                   </Box>
                                       {moment(formatedDate(res.createdAt)).isValid() && (
                      <Box>
                        <Time sx={{ textAlign: 'left', paddingLeft: 8 }}>
                          {moment(formatedDate(res.createdAt)).format('hh:mm a')}
                        </Time>
                      </Box>
                    )}
                 </>
               )}
             </React.Fragment>
           );
         })}
         <div ref={messagesEndRef} />
       </MessagesBox>
    </>
  );
};

const Conversation = ({ handleParentChange, getInboxWithoutLoading, getInbox, parentState }) => {
  var userName, userImage, secondUser;

  const { selectedChat, receiverId, receiverFollowers } = parentState;

  const dispatch = useDispatch();
  const [viewfreemiumsg, setviewviewfreemiumsg] = useState(false);
  const classes = messageInputStyles();

  const { userInfo, conversation = [], loading, blocked } = useSelector((state) => state.auth);

  const matches700 = useMediaQuery('(max-width:700px)');

  const [loader, setLoader] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);


  const [state, setState] = useState({
    isBlocked: false,
    typing: false,
    istyping: false,
    messages: conversation,
    image: [],
    imageUpload: false,
    message: '',
    openDeleteSuccessfull: false,
    openDelete: false,
    openBlock: false,
    openBlockSuccessful: false,
    openReportUser: false,
    userName: '',
    userImage: '',
  });

  const handleChange = (name, value) => {
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate()

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfileRedirections = (user) => {
    navigate(`/profile/public/${user._id}`)
  };

  const handleConversation = async () => {
    const updatedBlocked = await api.get(`/user/blockedUsers/${userInfo?._id}`, config);
    updatedBlocked?.data['blocked']?.forEach((res) => {
      if (res?.userId?._id === state?.secondUser?._id) {
        handleChange('isBlocked', true);
      }
    });
  };
  const handleUnblock = async () => {
    dispatch(startLoading());
    let body = { name: 'blocked', url: `/user/unBlockAUser/${userInfo?._id}/${state?.secondUser?._id}` };
    try {
      const response =  await api.put(body.url, body, config)
      FireStore.updateUserinFirestoreOnlyRoom(userInfo?._id, response?.data?.data);
      handleChange('isBlocked', false);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message, { duration: 4000 });
      }
    } finally{
      dispatch(stopLoading())
    }
  };
  const setDateMessage = (values) => {
    handleChange('messages', [...values]);
  };

  useEffect(() => {
    setviewviewfreemiumsg(false);
    handleChange('messages', []);
    if (!(Object.keys(selectedChat).length === 0)) {
      FireStore.getAllMessageInRoom(
        userInfo?._id,
        selectedChat?._id,
        receiverId,
        () => {},
        setDateMessage
      );
      if (userInfo?._id === selectedChat?.userId1?._id) {
        secondUser = selectedChat?.userId2;
        userImage = selectedChat?.userId2?.image;
        userName = getFullName(selectedChat?.userId2);
      } else if (userInfo?._id === selectedChat?.userId2?._id) {
        secondUser = selectedChat?.userId1;
        userImage = selectedChat?.userId1?.image;
        userName = getFullName(selectedChat?.userId1);
      }
      handleChange('userName', userName);
      handleChange('userImage', userImage);
      handleChange('secondUser', secondUser);
      console.log('secondUser: ', secondUser);
      setIsDeleted(getUserStatus(secondUser) === 'deleted')
      let c = false;
      blocked?.forEach((res) => {
        console.log('res?.userId?._id: ', res?.userId?._id);
        if (secondUser?._id === res?.userId?._id) {
          c = true;
        }
      });
      handleChange('isBlocked', c);
    } else return;
    // eslint-disable-next-line
  }, [selectedChat]);

  useEffect(() => {
    FireStore.getAllCurrentUserRooms(userInfo?._id);
  }, []);
  useEffect(() => {
    handleChange('messages', [...conversation]);
    // eslint-disable-next-line
  }, [conversation]);

  const sendMessage = async () => {
    setLoader(true);
    const userStatus = await getSubsctiptionStatus(selectedChat?.userId2?.customerId);
    console.log('work', userStatus);
    if (userStatus !== 'Premium' && userStatus !== 'PremiumC') {
      setviewviewfreemiumsg(true);
    }

    const validMessage = state?.message.trim()
    if(!validMessage){
      toast.error("Empty Message or Spacing is not Allowed",{duration:4000})
      setLoader(false);
      return
    }

    const timestamp = serverTimestamp();
    const chatMessageObject = {
      user: userInfo,
      isRead: false,
      message: state?.message,
      type: 'text',
      image: '',
      deletedBy: [],
      createdAt: timestamp,
      updatedAt: timestamp,
    };
    if (state?.message !== '') {
      FireStore.sendChatMessage(
        selectedChat?._id,
        receiverId,
        chatMessageObject,
        () => {},
        '',
        false,
        null,
        userInfo
      );
      handleChange('message', '');
    }
    setTimeout(() => {
      setLoader(false);
    }, 1500);
  };

  const sendMessageOnEnter = (e) => {
    if (e.key === 'Enter') {
      sendMessage();
    }
  };

  const uploadFunction = async (e) => {
    let result = await uploadImagesToS3(e);
    let temp = [];
    result.forEach((res) => {
      temp.push(res?.imgrUrl);
    });
    handleChange('image', [...state.image, ...temp]);
  };
  const sendImage = async (e) => {
    const timestamp = serverTimestamp();
    const userStatus = await getSubsctiptionStatus(selectedChat?.userId2?.customerId);
    console.log('work', userStatus);
    if (userStatus !== 'Premium' && userStatus !== 'PremiumC') {
      setviewviewfreemiumsg(true);
    }
    const chatMessageObject = {
      user: userInfo,
      isRead: false,
      message: state.imgMsg ? state.imgMsg : '',
      type: 'image',
      image: state.image,
      deletedBy: [],
      createdAt: timestamp,
      updatedAt: timestamp,
    };
    if (state?.image?.length) {
      FireStore.sendChatMessage(
        selectedChat?._id,
        receiverId,
        chatMessageObject,
        () => {},
        '',
        false,
        null,
        userInfo
      );
      handleChange('image', []);
      handleChange('imageUpload', false);
      handleChange('imgMsg', '');
    }
  };

  useEffect(() => {
    let body = { name: 'blocked', url: `/user/blockedUsers/${userInfo?._id}` };
    dispatch(getFunction(body));
  }, [selectedChat]);

  const [isBlockOther, setisBlockOther] = useState(false);

  // const optionsArr = blocked?.some((e) => e?.userId?._id === selectedChat.userId2?._id)
  //   ? [
  //       { icon: report, function: 'openReportUser', alt: 'Report User' },
  //       { icon: deletex, function: 'openDelete', alt: 'Delete Chat' },
  //     ]
  //   : [
  //       { icon: block, function: 'openBlock', alt: 'Block User' },
  //       { icon: report, function: 'openReportUser', alt: 'Report User' },
  //       { icon: deletex, function: 'openDelete', alt: 'Delete Chat' },
  //     ];
  const optionsArr = isBlockOther || isDeleted
    ? [
        { icon: deletex, function: 'openDelete', alt: 'Delete Chat' },
      ]
    : [
        { icon: block, function: 'openBlock', alt: 'Block User' },
        { icon: report, function: 'openReportUser', alt: 'Report User' },
        { icon: deletex, function: 'openDelete', alt: 'Delete Chat' },
      ];


  return (
    <RightGrid item xs={12} sm={matches700 ? 12 : 7} md={8} lg={8}>
      {Object.keys(selectedChat).length === 0 ? (
        <FirstScreen>
          <NameRow sx={{ color: 'rgba(17, 17, 17, 0.8)' }}>Pick up where you left off</NameRow>
          <Message sx={{ color: 'rgba(17, 17, 17, 0.8)' }}>
            Select a conversation and chat away.
          </Message>
        </FirstScreen>
      ) : (
        <>
          <Header>
            <UserName onClick={()=>handleProfileRedirections(state?.secondUser)}>
              <Avatar
                src={isDeleted ? "" : getUserProfile(state?.secondUser)}
                alt="convo"
                sx={{ width: 50, height: 50, my: 1 }}
                style={{ marginRight: 10 }}
              />
              {/* {state?.userName == ' ' ? 'Trip Trader User' : state.userName} */}
              {state?.userName == ' ' || isDeleted ? 'Trip Trader User' : getFullName(state?.secondUser)}
            </UserName>
            {matches700 ? (
              <div>
                <IconButton
                  id="basic-button"
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                >
                  <img src={dots} alt="dots" />
                </IconButton>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  {optionsArr.map((res, i) => {
                    return (
                      <MenuItem sx={{ opacity: 0.4 }}>
                        <Tooltip title={res?.alt}>
                          <img
                            style={{ cursor: 'pointer' }}
                            alt={res?.alt}
                            src={res.icon}
                            onClick={() => handleChange(res.function, true)}
                            key={i}
                          />
                        </Tooltip>
                      </MenuItem>
                    );
                  })}
                </Menu>
              </div>
            ) : state?.userName != ' ' ? (
              <Box sx={{ display: 'flex', alignItems: 'center', opacity: 0.4, gap: 2 }}>
                {state?.isBlocked && (
                  <Button onClick={handleUnblock} variant="outlined" color="error">
                    Unblock
                  </Button>
                )}
                {optionsArr.map((res, i) => {
                  return (
                    <Tooltip title={res?.alt}>
                      <img
                        style={{
                          marginRight: 15,
                          cursor: 'pointer',
                          display: res.alt === 'Block User' && state?.isBlocked ? 'none' : '',
                        }}
                        src={res.icon}
                        onClick={() => handleChange(res.function, true)}
                        alt=""
                        key={i}
                      />
                    </Tooltip>
                  );
                })}
              </Box>
            ) : (
              ''
            )}
          </Header>
          {loading && (
            <div style={{ position: 'absolute', top: '45%', left: '40%' }}>
              <img src={GreenLoader} width="80" alt="GreenLoader" />
            </div>
          )}
          

          <CustomConversationBox
            receiverFollowers={receiverFollowers}
            setDateMessage={setDateMessage}
            receiverId={receiverId}
            selectedChat={selectedChat}
            messages={state?.messages}
            handleChange={handleChange}
            setisBlockOther={setisBlockOther}
            setIsDeleted={setIsDeleted}
            isDeleted={isDeleted}
            handleProfileRedirections={handleProfileRedirections}
          />
          <FooterMain>
            {viewfreemiumsg ? (
              <p
                style={{
                  color: 'rgba(17, 17, 17, 0.4)',
                  fontFamily: 'Poppins-Medium',
                  backgroundColor: 'white',
                  fontSize: '0.8rem',
                  zIndex: '20',
                  position: 'absolute',
                  bottom: '73px',
                  padding: '1rem',
                }}
              >
                The person you messaged is not currently a subscribed user. We have notified them
                about your message, and they will be able to reply once they subscribe.
              </p>
            ) : (
              ''
            )}

            {/* {blocked?.some((e) => e?.userId?._id === selectedChat.userId2?._id) ? ( */}
            {isDeleted ? (
              <Time sx={{ textAlign: 'center', mb: 5 }}>
                This User has Delete the Account.
              </Time>
            ) : isBlockOther || (state?.isBlocked && state?.userName != ' ') ? (
              <Time sx={{ textAlign: 'center', mb: 5 }}>
                {state?.isBlocked && `You have blocked this user.`}
                {isBlockOther && `You can't send message to this user.`}
              </Time>
            ) : (
              <Footer sx={{ paddingLeft: 3, paddingRight: 3 }}>
                <img
                  src={attachment}
                  alt="attachment"
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleChange('imageUpload', true)}
                />
                <img
                  onClick={(e) => handleChange('openEmoji', true)}
                  src={smily}
                  alt="smily"
                  style={{ cursor: 'pointer' }}
                />
                <TextField
                  sx={{ width: '80%' }}
                  value={state.message}
                  onKeyPress={sendMessageOnEnter}
                  onChange={(e) => handleChange('message', e.target.value)}
                  className={classes.root}
                  inputProps={{
                    style: { color: '#1E3625', zIndex: 20, height: '25px' },
                  }}
                  placeholder={'Type your message here'}
                />
                {loader ? (
                  <Loader styl={{}} width={'30'} />
                ) : (
                  <SendButton onClick={sendMessage}>
                    <img src={send} alt="send" />
                  </SendButton>
                )}
              </Footer>
            )}
            {/* // ))} */}
          </FooterMain>
        </>
      )}
      <ImageModal
        _state={state}
        stateName="imageUpload"
        handle={handleChange}
        sendImage={sendImage}
        uploadFunction={uploadFunction}
        open={state.imageUpload}
        _setState={setState}
      />
      <Emoji data={state} open={state.openEmoji} handle={handleChange} stateName="openEmoji" />
      <BlockUser
        // isBlock={state?.isBlocked}
        handleConversation={handleConversation}
        data={state}
        open={state.openBlock}
        handle={handleChange}
        stateName="openBlock"
      />
      <DeleteMessage
        handleParentChange={handleParentChange}
        selectedChat={selectedChat}
        getInbox={getInbox}
        data={state}
        state={parentState}
        open={state.openDelete}
        handle={handleChange}
        stateName="openDelete"
      />
      <ReportUser
        data={state}
        open={state.openReportUser}
        handle={handleChange}
        stateName="openReportUser"
      />
      <BlockSuccessful
        data={state}
        open={state.openBlockSuccessful}
        handle={handleChange}
        stateName="openBlockSuccessful"
      />
      <ReportSuccessful
        data={state}
        open={state.openReportSuccessful}
        handle={handleChange}
        stateName="openReportSuccessful"
      />
      <DeleteSuccessful
        data={state}
        state={parentState}
        open={state.openDeleteSuccessfull}
        handle={handleChange}
        stateName="openDeleteSuccessfull"
      />
    </RightGrid>
  );
};
export default Conversation;
